module.exports = __webpack_public_path__ + "static/media/MariaBurei.b4c04655.jpg";